import {useModel1ValidationRegistryQuery} from "../query";


const useValidations = (model1) => {
    // LEGACY code used to perform validation on the frontend, removed because too complicated
    // to maintain front end and backend validations.

    //const [validationErrors, setValidationError] =  useState({})

    // const warningValidationSchema = useMemo(() => yup.object({
    //     // datetime is expected to be between 07:00 and 09:00
    //     datetime: yup.date().nullable().test('is-valid-time', t('warnings.datetime7h009h00'), function (value) {
    //         // Check if the value is a valid date
    //         if (isValidDate(value)) {
    //             const hour = value.getHours(); // Extract the hour from the date
    //             const minute = value.getMinutes(); // Extract the minute from the date
    //             const minuteSinceMidnight = hour * 60 + minute; // Calculate the minutes since midnight
    //             return minuteSinceMidnight >= 7 * 60 && minuteSinceMidnight <= 9 * 60; // Check if the hour is between 7 and 9 (inclusive)
    //         }
    //         return true
    //     }),
    //     TA: yup.number().transform((value) => Number.isNaN(value) ? null : value ).nullable().test('is-valid-ta', t('warnings.ta'), function (value) {
    //         const T_MIN = Number(this.parent.T_MIN);
    //         const T_MAX = Number(this.parent.T_MAX);
    //         const TA = value;
    //         if(TA && T_MIN && !Number.isNaN(T_MIN) && TA < T_MIN) {
    //             return false
    //         }
    //         return !(TA && T_MAX && !Number.isNaN(T_MAX) && TA > T_MAX);
    //
    //     }),
    //     T_MIN: yup.number().transform((value) => Number.isNaN(value) ? null : value ).nullable().test('is-valid-t-min', t('warnings.t_min'), function (value) {
    //         const T_MIN = value;
    //         const T_MAX = Number(this.parent.T_MAX);
    //         return !(T_MIN && T_MAX && !Number.isNaN(T_MAX) && T_MIN > T_MAX);
    //
    //     }),
    //     T_MAX: yup.number().transform((value) => Number.isNaN(value) ? null : value ).nullable().test('is-valid-t-max', t('warnings.t_max'), function (value) {
    //         const T_MIN = Number(this.parent.T_MIN);
    //         const T_MAX = value;
    //         return !(T_MIN && T_MAX && !Number.isNaN(T_MIN) && T_MIN > T_MAX);
    //
    //     })
    // }), [t]);

    // useEffect(() => {
    //     const validate = async (values) => {
    //         const error = {};
    //         await schema.validate(values, {abortEarly: false}).catch((err) => {
    //             err.inner.forEach((e) => {
    //                 error[e.path] = e.message;
    //             });
    //         });
    //         setValidationError(error);
    //     };
    //
    //     validate(values);
    // }, [values, schema]);

    const validationRegistryQuery = useModel1ValidationRegistryQuery();
    const validationRegistry = validationRegistryQuery.data || {}

    const allValidations = {...model1.validationWarnings, ...model1.validationErrors}

    return Object.entries(allValidations).reduce((acc, [key, value]) => {
        if (Array.isArray(value)){
            acc[key] = (value.map((v) => validationRegistry[v] || v)).join(', ');
        }
        else if (typeof value === 'string') {
            acc[key] = validationRegistry[value] || value;
        }
        return acc;
    }, {});
}

export default useValidations;